import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useAdminMenuHighlight = () => {
  const location = useLocation();

  useEffect(() => {
    const routePath = location.pathname; // e.g., /login/2fa/settings
    const adminMenu = document.getElementById('adminmenu');

    if (!adminMenu) return;

    // Clear all current classes
    adminMenu.querySelectorAll('.current').forEach(el => el.classList.remove('current'));
    // adminMenu.querySelectorAll('.wp-has-current-submenu').forEach(el =>
    //   el.classList.remove('wp-has-current-submenu', 'wp-menu-open')
    // );

    // Normalize route to find the best match
    const routeSegments = routePath.split('/').filter(Boolean); // ["login", "2fa", "settings"]

    let bestMatchLink = null;
    let bestMatchScore = -1;

    adminMenu.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href');
      if (!href.includes('page=ultimate-security')) return;

      // Check hash route part
      const hash = link.hash.replace(/^#/, '');
      const linkSegments = hash.split('/').filter(Boolean);

      // Calculate how closely the href matches the current path
      let score = 0;
      for (let i = 0; i < Math.min(linkSegments.length, routeSegments.length); i++) {
        if (linkSegments[i] === routeSegments[i]) {
          score++;
        } else {
          break;
        }
      }

      if (score > bestMatchScore) {
        bestMatchScore = score;
        bestMatchLink = link;
      }
    });

    if (bestMatchLink) {
      const li = bestMatchLink.closest('li');
      li?.classList.add('current');

      const parentLi = li?.closest('.wp-has-submenu');
      // if (parentLi) {
      //   parentLi.classList.add('wp-has-current-submenu', 'wp-menu-open');
      // }
    }
  }, [location]);
};

export default useAdminMenuHighlight;
